export const SLICER_PANEL_MIN_WIDTH = 176
export const SLICER_PANEL_MAX_WIDTH = 800
export const SLICER_PANEL_DEFAULT_WIDTH = 392
export const SLICER_PANEL_WIDE = 400
export const SLICER_PANEL_WIDE_CLASS = 'slicer-panel-wide'
